import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { getCarelonProviderDirectoryFeatureFlags } from '@lyrahealth-inc/shared-app-logic/src/features/carelonProviderDirectory/featureFlags'
import type { CarelonDirectoryPlacementContext } from '@lyrahealth-inc/shared-app-logic/src/features/carelonProviderDirectory/types'
import { getCarelonDirectoryPlacementProps } from '@lyrahealth-inc/shared-app-logic/src/features/carelonProviderDirectory/utils'
import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'

import { getCustomerName } from '../../data/customer/customerSelectors'
import {
  getIsSelfCarelonOutpatientTherapySearch,
  getOnboardSelectedTreatmentOption,
} from '../../features/onboard/data/onboardSelectors'
import { getSearcherDOB, getShownTierPage } from '../../features/triage/data/triageSelectors'

// Keep the search inputs here so screens and tracking only need to specify the placement
export const useCarelonDirectoryPlacement = () => {
  const customerName = useSelector(getCustomerName)
  const selectedTreatmentOption = useSelector(getOnboardSelectedTreatmentOption)
  const recommendationTier = useSelector(getShownTierPage)
  const isSelfCarelonOutpatientTherapySearch = useSelector(getIsSelfCarelonOutpatientTherapySearch)
  const searcherDOB = useSelector(getSearcherDOB)
  const flags = useFlags()

  return useCallback(
    (placement: CarelonDirectoryPlacementContext) =>
      getCarelonDirectoryPlacementProps({
        customerName,
        selectedTreatmentOption,
        recommendationTier,
        // Map new customer release flags in the shared carelonProviderDirectory/featureFlags.ts mapper.
        featureFlags: getCarelonProviderDirectoryFeatureFlags(flags),
        isSelfCarelonOutpatientTherapySearch,
        searcherDOB,
        placement,
      }),
    [
      customerName,
      selectedTreatmentOption,
      recommendationTier,
      flags,
      isSelfCarelonOutpatientTherapySearch,
      searcherDOB,
    ],
  )
}
